import { Injectable } from "@angular/core";
import {
  FieldDependency,
  FieldDependencyAction,
  FieldDependencyProperty,
} from "@cotecna/dynamic-view-engine";

@Injectable({
  providedIn: "root",
})
export class ManageDependenciesService {
  translateFormDependenciesToBoolean(formControls: any[]) {
    for (const control of formControls) {
      if (control.dependencies?.length) {
        control.dependencies.forEach((dependency) => {
          this.translateFormDependencyValueToBoolean(dependency);
        });
      }
    }
  }

  private translateFormDependencyValueToBoolean(dependency: FieldDependency) {
    if (dependency.trigger && dependency.trigger.actions?.length) {
      dependency.trigger.actions.forEach((action: FieldDependencyAction) => {
        switch (action.property) {
          case FieldDependencyProperty.visible:
          case FieldDependencyProperty.required:
          case FieldDependencyProperty.readonly:
            action.value = this.convertValueToBoolean(action.value);
            break;
        }
      });
    }
  }

  private convertValueToBoolean(value: any) {
    if (typeof value === "boolean") return value;
    else if (typeof value === "string") {
      if (value === "True" || value === "true" || value === "1") return true;
      else return false;
    } else if (typeof value === "number") {
      return !!value;
    }
  }
}
